import {createRouter, createWebHistory} from 'vue-router'
import HomePage from "@/pages/home-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import PolicyPage from "@/pages/policy-page.vue";

const routes = [
  {
    path: '',
    name: 'home',
    component: HomePage,
    meta: {
      title: "Home"
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsPage,
    meta: {
      title: "Terms of Service"
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: PolicyPage,
    meta: {
      title: "Privacy Policy"
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'Alcor Innovative | ' + to.meta?.title : 'Alcor Innovative'
})

export default router
